import './CategoryThingsContent.svelte.css';
/* src/components/CategoryThingsContent.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher, onMount } from "../../_snowpack/pkg/svelte.js";
import { DialogContent } from "../../_snowpack/pkg/svelte-accessible-dialog.js";
import { CloseButton } from "./button-elements/index.js";
import { CreateThingForm, CountText, ThingsDraggable } from "./index.js";
import { groupedThings } from "../stores/index.js";
import { MAX_THING_COUNT } from "../data/constants.js";

function create_else_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "aria-hidden", "true");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (45:2) {#if showThings && thingsCount}
function create_if_block_1(ctx) {
	let thingsdraggable;
	let current;
	thingsdraggable = new ThingsDraggable({ props: { category: /*category*/ ctx[0] } });

	return {
		c() {
			create_component(thingsdraggable.$$.fragment);
		},
		m(target, anchor) {
			mount_component(thingsdraggable, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const thingsdraggable_changes = {};
			if (dirty & /*category*/ 1) thingsdraggable_changes.category = /*category*/ ctx[0];
			thingsdraggable.$set(thingsdraggable_changes);
		},
		i(local) {
			if (current) return;
			transition_in(thingsdraggable.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(thingsdraggable.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(thingsdraggable, detaching);
		}
	};
}

// (51:2) {#if thingsCount < MAX_THING_COUNT}
function create_if_block(ctx) {
	let div;
	let createthingform;
	let t;
	let counttext;
	let current;

	createthingform = new CreateThingForm({
			props: { categoryId: /*category*/ ctx[0].id }
		});

	createthingform.$on("created", /*scrollToBottom*/ ctx[4]);

	counttext = new CountText({
			props: {
				count: /*thingsCount*/ ctx[1],
				countType: "THING"
			}
		});

	return {
		c() {
			div = element("div");
			create_component(createthingform.$$.fragment);
			t = space();
			create_component(counttext.$$.fragment);
			attr(div, "class", "jd-create-container svelte-1j1m6ar");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(createthingform, div, null);
			append(div, t);
			mount_component(counttext, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const createthingform_changes = {};
			if (dirty & /*category*/ 1) createthingform_changes.categoryId = /*category*/ ctx[0].id;
			createthingform.$set(createthingform_changes);
			const counttext_changes = {};
			if (dirty & /*thingsCount*/ 2) counttext_changes.count = /*thingsCount*/ ctx[1];
			counttext.$set(counttext_changes);
		},
		i(local) {
			if (current) return;
			transition_in(createthingform.$$.fragment, local);
			transition_in(counttext.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(createthingform.$$.fragment, local);
			transition_out(counttext.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(createthingform);
			destroy_component(counttext);
		}
	};
}

// (33:0) <DialogContent   class="jd-dialog-content--w-md jd-dialog-content--h-full"   aria-label={`manage category ${category.jdReadableId}, ${category.name}`} >
function create_default_slot(ctx) {
	let div1;
	let div0;
	let code;
	let t0_value = /*category*/ ctx[0].jdReadableId + "";
	let t0;
	let t1;
	let strong;
	let t2_value = /*category*/ ctx[0].name + "";
	let t2;
	let t3;
	let closebutton;
	let t4;
	let current_block_type_index;
	let if_block0;
	let t5;
	let if_block1_anchor;
	let current;
	closebutton = new CloseButton({});
	closebutton.$on("click", /*handleClose*/ ctx[3]);
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*showThings*/ ctx[2] && /*thingsCount*/ ctx[1]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*thingsCount*/ ctx[1] < MAX_THING_COUNT && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			code = element("code");
			t0 = text(t0_value);
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			t3 = space();
			create_component(closebutton.$$.fragment);
			t4 = space();
			if_block0.c();
			t5 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
			attr(code, "class", "jd-id");
			attr(strong, "class", "jd-name");
			attr(div0, "class", "jd-id-and-name");
			attr(div1, "class", "jd-header-in-list svelte-1j1m6ar");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, code);
			append(code, t0);
			append(div0, t1);
			append(div0, strong);
			append(strong, t2);
			append(div1, t3);
			mount_component(closebutton, div1, null);
			insert(target, t4, anchor);
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, t5, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*category*/ 1) && t0_value !== (t0_value = /*category*/ ctx[0].jdReadableId + "")) set_data(t0, t0_value);
			if ((!current || dirty & /*category*/ 1) && t2_value !== (t2_value = /*category*/ ctx[0].name + "")) set_data(t2, t2_value);
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				} else {
					if_block0.p(ctx, dirty);
				}

				transition_in(if_block0, 1);
				if_block0.m(t5.parentNode, t5);
			}

			if (/*thingsCount*/ ctx[1] < MAX_THING_COUNT) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*thingsCount*/ 2) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(closebutton.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(closebutton.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(closebutton);
			if (detaching) detach(t4);
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(t5);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

function create_fragment(ctx) {
	let dialogcontent;
	let current;

	dialogcontent = new DialogContent({
			props: {
				class: "jd-dialog-content--w-md jd-dialog-content--h-full",
				"aria-label": `manage category ${/*category*/ ctx[0].jdReadableId}, ${/*category*/ ctx[0].name}`,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(dialogcontent.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dialogcontent, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const dialogcontent_changes = {};
			if (dirty & /*category*/ 1) dialogcontent_changes["aria-label"] = `manage category ${/*category*/ ctx[0].jdReadableId}, ${/*category*/ ctx[0].name}`;

			if (dirty & /*$$scope, thingsCount, category, showThings*/ 519) {
				dialogcontent_changes.$$scope = { dirty, ctx };
			}

			dialogcontent.$set(dialogcontent_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dialogcontent.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dialogcontent.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dialogcontent, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $groupedThings;
	component_subscribe($$self, groupedThings, $$value => $$invalidate(6, $groupedThings = $$value));
	var _a;
	
	let { category } = $$props;
	let modalEl;
	let thingsCount = 0;
	let showThings = false; // delay to make dialog loading fast
	const dispatch = createEventDispatcher();

	const handleClose = () => {
		dispatch("close");
	}; // prettier-ignore

	// Scroll to area bottom when new thing is added.
	const scrollToBottom = e => {
		const ITEM_H = 40;
		modalEl = document.querySelector(`[data-svelte-dialog-content]`);

		setTimeout(
			() => {
				if (modalEl) modalEl.scrollTop = modalEl.scrollHeight + ITEM_H;
			},
			50
		);
	};

	onMount(() => {
		setTimeout(
			() => {
				$$invalidate(2, showThings = true);
			},
			50
		); // prettier-ignore
	});

	$$self.$$set = $$props => {
		if ("category" in $$props) $$invalidate(0, category = $$props.category);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$groupedThings, category, _a*/ 97) {
			$: {
				if ($groupedThings && $groupedThings[category.id]) $$invalidate(1, thingsCount = $$invalidate(5, _a = $groupedThings[category.id]) === null || _a === void 0
				? void 0
				: _a.length);
			}
		}
	};

	return [
		category,
		thingsCount,
		showThings,
		handleClose,
		scrollToBottom,
		_a,
		$groupedThings
	];
}

class CategoryThingsContent extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { category: 0 });
	}
}

export default CategoryThingsContent;